import { connectorsForWallets, getDefaultConfig } from '@rainbow-me/rainbowkit';
import { arbitrum } from 'wagmi/chains';
import { createStorage, cookieStorage, createConfig, http } from 'wagmi';
import {
  backpackWallet,
  binanceWallet,
  coinbaseWallet,
  metaMaskWallet,
  okxWallet,
  rabbyWallet,
  walletConnectWallet,
} from '@rainbow-me/rainbowkit/wallets';
export type HexString = `0x${string}`;
const connectors = connectorsForWallets(
  [
    {
      groupName: 'Recommend',
      wallets: [
        okxWallet,
        metaMaskWallet,
        walletConnectWallet,
        coinbaseWallet,
        binanceWallet,
        backpackWallet,
        rabbyWallet,
      ],
    },
  ],
  {
    appName: 'AI Earn',
    projectId: '014279d7b6a9226f343a5d181777bb83',
  },
);
export const wagmiConfig = createConfig({
  chains: [arbitrum],
  connectors,
  multiInjectedProviderDiscovery: false,
  transports: {
    [arbitrum.id]: http(),
  },
});

// getDefaultConfig({
// appName: 'AI Earn',
// projectId: '014279d7b6a9226f343a5d181777bb83',
// chains: [arbitrum],
// ssr: true,
// storage: createStorage({
//   storage: cookieStorage,
// }),
// });
